import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";
import { ArrowForwardRounded } from "@mui/icons-material";

import { createState } from "@/global/store/zustand_store";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useFilterApis } from "../../GameFilters/useFilterApis";
import { useInternalAuth } from "@/global/hooks/useInternalAuth";
import { useTicketmaster } from "@/global/hooks/useTicketmaster";
import { useTicketsdotcom } from "@/global/hooks/useTicketsdotcom";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { useFraudPrevention } from "@/global/context/FraudPreventionProvider";

import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";

export const useUnlockExclusiveAccessModal = createState({
  isOpen: false,
  hasModalOpened: false,
});

export const UnlockExclusiveAccessModal = () => {
  /** hooks */
  const { uiConfigs } = useTeamConfig();
  const { sm } = useCssMediaQuery("down");
  const { redirectLoading } = useInternalAuth();
  const { oktaAuthLoading } = useTicketsdotcom();
  const { getInventoryFilters } = useFilterApis();
  const { checkBrokerEmail } = useFraudPrevention();
  const modalState = useUnlockExclusiveAccessModal();
  const { isLoading: isAuthLoading } = useTicketmaster();

  /** states */
  const isUnlockExclusiveAccessModalEnabled = uiConfigs?.unlockExclusiveAccessModal?.enabled || false; // prettier-ignore

  /** functions */
  async function handleConfirm() {
    modalState.set({ isOpen: false });
    const cartConfirmBtn = document.getElementById("confirm-game-selection-btn"); // prettier-ignore
    cartConfirmBtn?.click();
  }

  async function onClickYes() {
    modalState.set({ isOpen: false, hasModalOpened: true });
  }

  if (!isUnlockExclusiveAccessModalEnabled) return null;

  return (
    <NotificationModal
      hideTitleIcon
      hidePrimaryButton
      hideSecondaryButton
      title={
        uiConfigs?.unlockExclusiveAccessModal?.title ||
        "Unlock exclusive access!"
      }
      isOpen={modalState.isOpen}
      onClose={() => modalState.set({ isOpen: false, hasModalOpened: true })}
      paperProps={{ style: { marginLeft: 2, marginRight: 2 } }}
      renderBody={() => (
        <Box>
          <Box p={sm ? 2 : 3}>
            <Box>
              <Typography variant="body1">
                {uiConfigs?.unlockExclusiveAccessModal?.description ||
                  "Don't miss the chance to purchase exclusive tickets!"}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      renderFooter={() => {
        return (
          <Stack
            py={2}
            px={2}
            gap={2}
            width={"100%"}
            justifyContent={"flex-end"}
            direction={"row"}
          >
            <LoadingButton
              loading={
                isAuthLoading ||
                getInventoryFilters.isLoading ||
                checkBrokerEmail.isLoading
              }
              size={"large"}
              disabled={
                isAuthLoading ||
                getInventoryFilters.isLoading ||
                checkBrokerEmail.isLoading ||
                oktaAuthLoading ||
                redirectLoading
              }
              variant={"outlined"}
              endIcon={<ArrowForwardRounded />}
              onClick={handleConfirm}
              sx={{
                width: sm ? "fit-content" : "180px",
                fontWeight: 600,
              }}
            >
              Continue
            </LoadingButton>

            <ModalActionButton
              size="small"
              variant="primary"
              onClick={onClickYes}
              style={{
                width: sm ? "fit-content" : "180px",
                fontWeight: 600,
                borderRadius: 99,
              }}
            >
              {uiConfigs?.unlockExclusiveAccessModal?.buttonText || "YES!"}
            </ModalActionButton>
          </Stack>
        );
      }}
    />
  );
};
